import { ArrowRightCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowRightCircle12Line = createIcon(
  ArrowRightCircle,
  12,
  "Line"
);
export const IconArrowRightCircle16Line = createIcon(
  ArrowRightCircle,
  16,
  "Line"
);
export const IconArrowRightCircle20Line = createIcon(
  ArrowRightCircle,
  20,
  "Line"
);
export const IconArrowRightCircle24Line = createIcon(
  ArrowRightCircle,
  24,
  "Line"
);
export const IconArrowRightCircle32Line = createIcon(
  ArrowRightCircle,
  32,
  "Line"
);
export const IconArrowRightCircle48Line = createIcon(
  ArrowRightCircle,
  48,
  "Line"
);
export const IconArrowRightCircle64Line = createIcon(
  ArrowRightCircle,
  64,
  "Line"
);
